import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import history from 'providers/history';
import { Route, Router, Switch } from 'react-router-dom';

import { Provider } from 'react-redux';
import store from 'redux/store';

// Import global styles and assets here
import 'bootstrap/dist/css/bootstrap.min.css';

import Home from 'containers/pages/Home/Home';

import Layout from 'components/global/application/Layout';
import NewsPage from 'components/pages/news/NewsPage';
import NewsletterPage from 'components/pages/newsletter/NewsletterPage';
import NotFoundPage from 'components/pages/notFound/NotFoundPage';
import StaffPage from 'components/pages/staff/StaffPage';
import VintageGuitarsPage from 'components/pages/vintageGuitars/VintageGuitarsPage';
import Accessories from 'containers/pages/accessories/AccessoriesPage';
import BrandInfoPage from 'containers/pages/brand/BrandInfo';
import BrandsInfoPage from 'containers/pages/brand/BrandsInfo';
import DefaultPage from 'containers/pages/default/DefaultPage';
import InventoryPage from 'containers/pages/inventory/InventoryPage';

import NewArrivalsPage from 'containers/pages/NewArrivalsPage/NewArrivalsPage';
import VintageInstrumentsPage from 'containers/pages/VintageInstrumentsPage/VintageInstrumentsPage';
import VintageNewArrivalsPage from 'containers/pages/VintageNewArrivalsPage/VintageNewArrivalsPage';

if (process.env.NODE_ENV !== 'production') {
    localStorage.setItem('debug', 'gruhn-modern-web:*');
}

// Third party styles for slick carousel
import 'slick-carousel/slick/slick.css';

// primary styles
import 'styles/main.sass';

// Make browser return to the top of the page on navigation
history.listen((location, action) => {
    window.scrollTo(0, 0);
});

const appDiv = document.getElementById('app');

render(
    <Provider store={store}>
        <Router history={history}>
            <AppContainer>
                <Layout>
                    <Switch>
                        <Route path="/" exact component={Home} />
                        <Route exact path="/new-arrivals" component={NewArrivalsPage} />
                        <Route exact path="/vintage-new-arrivals" component={VintageNewArrivalsPage} />
                        <Route exact path="/inventory/vintage" component={VintageInstrumentsPage} />
                        <Route path="/inventory" component={InventoryPage} />
                        <Route path="/accessories" component={Accessories} />
                        <Route path="/news" component={NewsPage} />
                        <Route path="/newsletter" component={NewsletterPage} />
                        <Route path="/vintage-guitars" component={VintageGuitarsPage} />
                        <Route path="/gruhn-guitars-staff" component={StaffPage} />
                        <Route path="/brand" component={BrandsInfoPage} exact />
                        <Route path="/brands" component={BrandsInfoPage} exact />
                        <Route path="/brand/:brand/:year?/:model?" component={BrandInfoPage} />
                        <Route path="/brands/:brand/:year?/:model?" component={BrandInfoPage} />
                        <Route
                            path="/user"
                            render={() => {
                                window.location.href = `${process.env.DRUPAL_URL}/user`;
                                return null;
                            }}
                        />
                        <Route path="/not-found" component={NotFoundPage} />
                        <Route path="/" component={DefaultPage} />
                    </Switch>
                </Layout>
            </AppContainer>
        </Router>
    </Provider>,
    appDiv
);



// WEBPACK FOOTER //
// ./src/App.tsx